import { Moon, Sun } from "lucide-react";
import { useTheme } from "./ThemeProvider";
import { useState, useEffect } from "react";

export function ThemeToggle() {
  const { setTheme, theme } = useTheme();
  const [isDark, setIsDark] = useState(() => {
    if (typeof window === "undefined") return false;
    return document.documentElement.classList.contains("dark");
  });

  // Sync icon state with theme changes
  useEffect(() => {
    const updateIcon = () => {
      if (typeof window !== "undefined") {
        setIsDark(document.documentElement.classList.contains("dark"));
      }
    };

    // Update immediately
    updateIcon();

    // Watch for class changes on the HTML element
    const observer = new MutationObserver(updateIcon);
    if (typeof window !== "undefined") {
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    return () => observer.disconnect();
  }, [theme]);

  const toggleTheme = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Get current theme from the actual DOM class to ensure accuracy
    const root = document.documentElement;
    const currentIsDark = root.classList.contains("dark");
    const newTheme = currentIsDark ? "light" : "dark";
    
    // Immediately update DOM
    root.classList.remove("light", "dark");
    root.classList.add(newTheme);
    
    // Update icon state immediately
    setIsDark(newTheme === "dark");
    
    // Update state and storage
    setTheme(newTheme);
  };

  return (
    <button 
      onClick={toggleTheme}
      type="button"
      className="relative w-9 h-9 rounded-lg hover:bg-muted transition-colors p-2 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-primary"
      aria-label="Toggle theme"
    >
      <Sun className={`h-4 w-4 absolute transition-all duration-300 ${isDark ? 'rotate-90 scale-0 opacity-0' : 'rotate-0 scale-100 opacity-100'}`} />
      <Moon className={`h-4 w-4 absolute transition-all duration-300 ${isDark ? 'rotate-0 scale-100 opacity-100' : 'rotate-90 scale-0 opacity-0'}`} />
      <span className="sr-only">Toggle theme</span>
    </button>
  );
}

